module.exports = __webpack_public_path__ + "img/embed.8af1995f.jpg";